import { render, staticRenderFns } from "./SegmentChoice.vue?vue&type=template&id=76c961da&scoped=true"
import script from "./SegmentChoice.vue?vue&type=script&lang=js"
export * from "./SegmentChoice.vue?vue&type=script&lang=js"
import style0 from "./SegmentChoice.vue?vue&type=style&index=0&id=76c961da&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c961da",
  null
  
)

export default component.exports